module.exports = __webpack_public_path__ + "img/9788997980437.0a691f4f.jpg";